import { emptyQuillHtml, richTextTagPattern } from './richText';

export const primaryTextQuillFormats = ['bold', 'italic'];

export const primaryTextQuillModules = {
  clipboard: {
    matchVisual: false
  },
  toolbar: [['bold', 'italic']]
};

export const getPrimaryTextEditorValue = (editor: any) => {
  const html = editor.root.innerHTML;
  return html === emptyQuillHtml ? '' : html;
};

export const setPrimaryTextEditorValue = (editor: any, value = '') => {
  if (!value) {
    editor.setText('', 'api');
    return;
  }

  if (richTextTagPattern.test(value)) {
    editor.clipboard.dangerouslyPasteHTML(value, 'api');
    return;
  }

  editor.setText(value, 'api');
};
